var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8502 24.2656L39.8349 33.833L10.4802 33.8666L16.4636 24.7524L34.8502 24.2656Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6316 33.6193L31.2999 15.8777C31.174 15.6427 30.9306 15.5 30.6705 15.5H22.1108C21.7164 15.5 21.3975 15.8189 21.3975 16.2134C21.3975 16.6078 21.7164 16.9267 22.1108 16.9267H30.2425L33.7922 23.6743C30.9054 23.6491 23.1681 23.5819 19.0645 23.5819C13.4839 23.5819 9.97615 33.3004 9.82509 33.7116C9.74957 33.9298 9.78313 34.1732 9.9174 34.3662C10.0517 34.5593 10.2699 34.6684 10.4964 34.6684H39.9938C40.2456 34.6684 40.4722 34.5341 40.6064 34.3243C40.7407 34.1061 40.7407 33.8459 40.6316 33.6193ZM11.5538 33.2416C11.9398 32.3353 12.5944 30.9002 13.4756 29.4818C14.7427 27.4425 16.7484 25.0087 19.0645 25.0087C23.6129 25.0087 32.6426 25.0926 34.5475 25.1094L38.819 33.2416H11.5538Z",
    fill: "#251B7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPNewIcon);
export default __webpack_public_path__ + "static/media/p-new-icon.3a07015516fe90abb3f9aadbe343e68c.svg";
export { ForwardRef as ReactComponent };